import { QUERY_KEYS } from "../../lib/query-constants"
import { useGenericQuery } from "../use-generic-query"

export const usePaymentPlans = ({ endpoint }) => {
    return useGenericQuery({
        queryKey: QUERY_KEYS.paymentPlans.all,
        endpoint: endpoint,
        onError: () => { },
        onSuccess: () => { },
        staleTime: Infinity,
    })
}